import { render, staticRenderFns } from "./Table-Activity.vue?vue&type=template&id=9a86ba44"
import script from "./Table-Activity.vue?vue&type=script&lang=js"
export * from "./Table-Activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports